<script>
// Libs
import moment from 'moment'
import numeral from 'numeral'
import Joi from '@hapi/joi'

// Components
import { NumberInput } from '@/components/form/number-input'

export default {
  props: {
    code: {
      type: String,
      default: ''
    },

    date: {
      type: Date,
      default: () => new Date()
    },

    latestDate: {
      type: Date,
      default: () => new Date()
    },

    interestPerMonth: {
      type: Number,
      default: 0
    },

    amount: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      form: {
        date: null,
        amount: null,
        redemptionAmount: null
      },
      visible: false,
      datePickerOptions: {
        disabledDate: time => time.getTime() < this.date
      }
    }
  },

  computed: {
    diffMonths() {
      if (this.form.date)
        return Math.ceil(
          moment(this.form.date).diff(this.latestDate, 'months', true)
        )

      return 0
    },

    totalInterest() {
      return this.diffMonths * this.interestPerMonth
    }
  },

  mounted() {
    this.visible = true
  },

  methods: {
    handleCancelButtonClick() {
      this.visible = false
    },

    handleSaveButtonClick() {
      this.validate()
        .then(() => {
          this.$emit('save', { ...this.form })
          this.visible = false
        })
        .catch(() => {
          this.$message.warning('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
        })
    },

    async validate() {
      const schema = Joi.object({
        date: Joi.date(),
        amount: Joi.number(),
        redemptionAmount: Joi.number()
      })

      return await schema.validateAsync(this.form, { allowUnknown: true })
    }
  },

  render() {
    const Form = () => (
      <el-form labelWidth="9rem">
        <el-form-item label="เลขที่ตั๋วขายฝาก">{this.code}</el-form-item>
        <el-form-item label="วันที่ไถ่ถอน">
          <el-date-picker
            value={this.form.date}
            style={{ width: '100%' }}
            onInput={value => {
              this.form.date = value
            }}
          />
        </el-form-item>
        <el-form-item label="ระยะเวลาคิดดอก">
          {this.diffMonths} เดือน
        </el-form-item>
        <el-form-item label="ดอกเบี้ยที่ต้องชำระ">
          {numeral(this.totalInterest).format('0,0.00')} บาท
        </el-form-item>
        <el-form-item label="ดอกเบี้ยที่รับชำระ">
          <NumberInput
            value={this.form.amount}
            min={0}
            onInput={value => {
              this.form.amount = value
            }}
          >
            <template slot="append">บาท</template>
          </NumberInput>
        </el-form-item>
        <el-form-item label="จำนวนเงินขายฝาก">
          {numeral(this.amount).format('0,0.00')} บาท
        </el-form-item>
        <el-form-item label="จำนวนเงินไถ่ถอน">
          <NumberInput
            value={this.form.redemptionAmount}
            min={0}
            onInput={value => {
              this.form.redemptionAmount = value
            }}
          >
            <template slot="append">บาท</template>
          </NumberInput>
        </el-form-item>
      </el-form>
    )

    const Footer = () => (
      <div>
        <el-row
          type="flex"
          gutter={16}
          justify="center"
          style={{ flexWrap: 'wrap' }}
        >
          <el-col span={null}>
            <el-button onClick={this.handleCancelButtonClick}>ยกเลิก</el-button>
          </el-col>
          <el-col span={null}>
            <el-button type="primary" onClick={this.handleSaveButtonClick}>
              บันทึก
            </el-button>
          </el-col>
        </el-row>
      </div>
    )

    return (
      <el-dialog
        title="ไถ่ถอน"
        visible={this.visible}
        appendToBody
        closeOnClickModal={false}
        closeOnPressEscape={false}
        showClose={false}
        customClass={this.$style.root}
        on={{
          'update:visible': value => {
            this.visible = value
          },
          closed: () => {
            this.$destroy()
          }
        }}
      >
        <Form />
        <Footer slot="footer" />
      </el-dialog>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  width: auto;
  max-width: 30rem;
}
</style>
